import angular from 'angular';
import Logger from '../shared/logger';

angular.module('TALENYA-FE').factory('Logger', () => ({
    info: Logger.info,
    warn: Logger.warn,
    error: Logger.error,
}));
